import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components-new/typography/typography';

import { FilterHeadlineItem } from './filter-headline-item';

interface FilterHeadlineProps {
  title: string;
  options: Array<{
    id: string;
    title: string;
    isChecked?: boolean;
    onClick?: () => void;
  }>;
  className?: string;
  titleClassName?: string;
  checkboxClassName?: string;
  filterHeadlineItemTypographyClassName?: string;
}

const FilterHeadline: React.FC<FilterHeadlineProps> = (props) => {
  const { title, options } = props;

  const titleClassNames = twMerge('text-gray300', props.titleClassName);

  return (
    <div className={twMerge('flex flex-col gap-y-1 item', props.className)}>
      <Typography className={titleClassNames} variant="heading-4" as="span">
        {title}
      </Typography>
      <div className="flex flex-col gap-y-2 mt-1">
        {options.map((option) => {
          return (
            <FilterHeadlineItem
              key={option.id}
              {...option}
              typographyClassName={props.filterHeadlineItemTypographyClassName}
              checkboxClassName={props.checkboxClassName}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FilterHeadline;
